<div *transloco="let t">
  <nav
    class="surface-overlay px-4 lg:px-6 shadow-2 flex justify-content-between relative lg:static align-items-center">
    <a [routerLink]="'/'">
      <img
        src="assets/images/logo-apprezzo.svg"
        height="50"
        class="max-w-10rem"
        alt="logo Apprezzoo"
        style="min-height: 84px" />
    </a>
    @if(isMenuButtonAvailable) {
    <a
      pRipple
      class="cursor-pointer block lg:hidden align-self-center text-700"
      pStyleClass="@next"
      enterFromClass="hidden"
      leaveToClass="hidden"
      [hideOnOutsideClick]="true"
      (click)="onToggleClick()"
      #menuButton>
      <i class="pi pi-bars text-4xl"></i>
    </a>
    }
    <div
      [ngStyle]="{ display: (pagesService.menuVisible$ | async) ? 'block' : 'none' }"
      class="header-nav flex-1 lg:flex absolute lg:static w-full surface-overlay left-0 top-100 z-2 lg:shadow-none"
      *ngIf="items$ | async as items">
      <ng-container *ngIf="isLoggedIn$ | async; then privateMenu; else publicMenu"></ng-container>

      <ng-template #privateMenu>
        <ul
          class="list-none p-0 m-0 flex select-none flex-column lg:flex-row flex-grow-1 justify-content-center align-items-start lg:align-items-center">
          <ng-container *ngFor="let item of items">
            <li *ngIf="item['private']" class="w-full lg:w-fit">
              <a
                (click)="navigateAndClose('/dashboard/' + item.url)"
                [ngClass]="{ active: isActive('/dashboard/' + item.url) }"
                pRipple
                class="flex px-3 py-3 font-medium text-medium transition-colors transition-duration-150 gap-2 align-items-center">
                <i class="pi + {{ item.icon }}"></i>
                {{ item.label }}
              </a>
            </li>
          </ng-container>
        </ul>
      </ng-template>

      <ng-template #publicMenu>
        <ul
          class="list-none p-0 m-0 flex select-none flex-column lg:flex-row flex-grow-1 justify-content-center align-items-start lg:align-items-center">
          <ng-container *ngFor="let item of items">
            <li *ngIf="!item['private']" class="w-full lg:w-fit">
              <a
                (click)="navigateAndClose(item.url!)"
                [ngClass]="{ active: isActive(item.url!) }"
                pRipple
                class="flex px-4 py-3 font-medium text-medium transition-colors transition-duration-150">
                <span>
                  {{ item.label }}
                </span>
              </a>
            </li>
          </ng-container>
        </ul>
      </ng-template>

      @defer (when !isLoading) {
      <div *ngIf="isLoggedIn$ | async; then privateButton; else publicButton"></div>
      <ng-template #privateButton>
        <ul
          class="list-none p-0 m-0 lg:flex select-none lg:flex-row border-top-1 surface-border lg:border-top-none lg:align-items-center">
          <li class="hidden lg:flex">
            <p-menu
              #menu
              [model]="(userMenuitems$ | async) || []"
              [popup]="true"
              class="pMenu"></p-menu>
            <p-button
              (onClick)="menu.toggle($event)"
              icon="pi pi-user"
              class="buttonProfile mr-2" />
          </li>

          <li class="flex lg:hidden w-full w-full">
            <p-menu
              [model]="(userMenuitems$ | async) || []"
              class="profileMenu w-full lg:w-fit"></p-menu>
          </li>

          <li class="languageSelector py-3 lg:p-0">
            <span
              class="px-1 language"
              (click)="currentLang !== 'it' && changeLanguage('it')"
              [ngStyle]="
                currentLang === 'it'
                  ? { color: 'var(--primary-color)', 'font-weight': 'bold' }
                  : { color: 'var(--text-color-light)' }
              "
              [ngClass]="{ 'cursor-pointer': currentLang !== 'it' }">
              ITA
            </span>
            |
            <span
              class="px-1 language"
              (click)="currentLang !== 'en' && changeLanguage('en')"
              [ngStyle]="
                currentLang === 'en'
                  ? { color: 'var(--primary-color)', 'font-weight': 'bold' }
                  : { color: 'var(--text-color-light)' }
              "
              [ngClass]="{ 'cursor-pointer': currentLang !== 'en' }">
              ENG
            </span>
          </li>
        </ul>
      </ng-template>

      <ng-template #publicButton>
        <ul
          class="list-none p-0 m-0 flex select-none flex-column lg:flex-row border-top-1 surface-border lg:border-top-none align-items-center column-gap-3">
          <li class="py-4">
            <p-button [rounded]="true" (onClick)="dialogService.showDialog()">
              {{ t('homepage.menuTop.registrati-o-accedi') }}
            </p-button>
          </li>

          <li class="languageSelector py-4 lg:p-0">
            <span
              class="px-1 language"
              (click)="currentLang !== 'it' && changeLanguage('it')"
              [ngStyle]="
                currentLang === 'it'
                  ? { color: 'var(--primary-color)', 'font-weight': 'bold' }
                  : { color: 'var(--text-color-light)' }
              "
              [ngClass]="{ 'cursor-pointer': currentLang !== 'it' }">
              ITA
            </span>
            |
            <span
              class="px-1 language"
              (click)="currentLang !== 'en' && changeLanguage('en')"
              [ngStyle]="
                currentLang === 'en'
                  ? { color: 'var(--primary-color)', 'font-weight': 'bold' }
                  : { color: 'var(--text-color-light)' }
              "
              [ngClass]="{ 'cursor-pointer': currentLang !== 'en' }">
              ENG
            </span>
          </li>
        </ul>
      </ng-template>
      } @placeholder {
      <div *ngIf="isLoggedIn$">
        <ul
          class="list-none p-0 m-0 flex select-none flex-column lg:flex-row border-top-1 surface-border lg:border-top-none align-items-center column-gap-3">
          <li class="py-4">
            <p-skeleton width="174px" height="44px" borderRadius="25px" />
          </li>
          <li class="surface-border lg:border-top-none lg:pb-0 pb-4">
            <p-skeleton width="65px" height="44px" borderRadius="25px" />
          </li>
        </ul>
      </div>
      <div *ngIf="!isLoggedIn$">
        <ul
          class="list-none p-0 m-0 flex select-none flex-column lg:flex-row border-top-1 surface-border lg:border-top-none align-items-center column-gap-3">
          <li class="py-4">
            <p-skeleton width="60px" height="44px" borderRadius="25px" />
          </li>
          <li class="surface-border lg:border-top-none lg:pb-0 pb-4">
            <p-skeleton width="65px" height="44px" borderRadius="25px" />
          </li>
        </ul>
      </div>

      }
    </div>
  </nav>

  <p-dialog [(visible)]="isVisible" appendTo="body" [modal]="true" [draggable]="false">
    <ng-template pTemplate="header">
      <div class="flex align-items-center"></div>
    </ng-template>
    <ng-template pTemplate="body">
      <app-login-signup (loginSuccess)="dialogService.hideDialog()"></app-login-signup>
    </ng-template>
  </p-dialog>
</div>
